import { render } from "./bookDetail.vue?vue&type=template&id=cfb669cc"
import script from "./bookDetail.vue?vue&type=script&lang=js"
export * from "./bookDetail.vue?vue&type=script&lang=js"

import "./bookDetail.vue?vue&type=style&index=0&id=cfb669cc&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__